import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ListState from '../states/list.state';
import { fetchFieldHistory } from '../actions/spa.actions';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const FieldHistorySlice = createSlice({
  name: 'fieldHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFieldHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFieldHistory.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.histories;
        state.meta = action.payload.pagination;
      })
      .addCase(fetchFieldHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default FieldHistorySlice.reducer;